<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Komentari</h3>
    </div>
    <div class="card-body">
      <div *ngFor="let comment of comments">
        - {{ comment }}
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">U redu</button>
    </div>
  </div>
</div>
